<template>
  <div class="content">
    <type-uav-item :content="content" />
  </div>
</template>

<script>
import TypeUavItem from "@/components/main/aboutUAV/modules/AboutUAVContentItem.vue";

export default {
  name: "type-uav-block",
  components: { TypeUavItem },
  props: {
    content: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  margin-bottom: 75px;
}
</style>
